import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy,
  Renderer2,
} from '@angular/core';

@Directive({
  standalone: true,
  selector: '[truncateText]'
})
export class TruncateTextDirective implements AfterViewInit, OnDestroy {
  @Input() public tooltipText: string;
  @Input() public maxLength: number = 0;
  @Input() public more: string;
  @Input() public less: string;

  private element: HTMLElement;
  private showComplete: boolean = false;
  private originalText: string | null;
  private textToShow: string;
  private removeMoreLinkListener?: () => void;

  public constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2,
  ) {}

  public ngAfterViewInit(): void {
    this.element = this.elementRef.nativeElement;
    this.originalText = this.element.textContent;
    this.textToShow = this.originalText ?? "";
    this.handleShow();
  }

  public ngOnDestroy(): void {
    this.removeMoreLinkListener?.();
  }

  private createMoreLink(label: string): HTMLElement {
    const span = this.renderer.createElement('span');
    this.renderer.setStyle(span, 'color', '#ff00ff');
    this.renderer.setStyle(span, 'cursor', 'pointer');
    this.renderer.addClass(span, 'lessMoreText');
    span.innerHTML = ' ' + label;
    this.removeMoreLinkListener = this.renderer.listen(span, 'click', (event: Event) => {
      event.stopPropagation();
      this.showComplete = !this.showComplete;
      this.handleShow();
    });
    return span;
  }

  private shouldTruncate(): boolean {
    if (!this.originalText || this.originalText.length <= this.maxLength) return false;

    const truncationSuffixLength = 3 + 1 + (this.more?.length || 0);
    return this.originalText.length > this.maxLength + truncationSuffixLength;
  }

  private handleShow()
  {
    this.removeMoreLinkListener?.();
    this.removeMoreLinkListener = undefined;
    const originalText = this.originalText;

    if (originalText && this.shouldTruncate() && !this.showComplete)
    {
      this.textToShow = originalText.substring(0,this.maxLength) + "...";
      this.renderer.setStyle(this.element, 'display', 'block');
      this.renderer.setStyle(this.element, 'overflow', 'hidden');
      this.renderer.setStyle(this.element, 'textOverflow', 'ellipsis');

      this.element.innerHTML = this.textToShow;

      this.renderer.appendChild(this.element, this.createMoreLink(this.more));
    }
    else
    {
      this.textToShow = this.originalText ?? "";
      this.renderer.setStyle(this.element, 'display', '');
      this.renderer.setStyle(this.element, 'overflow', '');
      this.renderer.setStyle(this.element, 'textOverflow', '');
      
      this.element.innerHTML = this.textToShow;

      if (this.showComplete && this.shouldTruncate())
      {
        this.renderer.appendChild(this.element, this.createMoreLink(this.less));
      }
    }
    
  }

  @HostListener('mouseenter') public enter(): void {
    if (this.originalText && this.originalText.length > this.maxLength)
    {
      this.renderer.setStyle(this.element, 'cursor', 'pointer');
      if (this.tooltipText !== undefined && this.tooltipText.length > 0) {
        this.element.title = this.tooltipText;
        return;
      } else if (this.element.nodeName === 'INPUT') {
        this.element.title = this.elementRef?.nativeElement?.value;
        return;
      }
      this.element.title = this.originalText ?? "";
    }
    else
    {
      this.renderer.setStyle(this.element, 'cursor', '');
      if (this.tooltipText === undefined || this.tooltipText.length === 0) {
        this.element.title = "";
      }
    }

  }

  @HostListener('click') public click(): void {
    this.showComplete = !this.showComplete;
    this.handleShow();
  }
}

